"use client"
import useEmblaCarousel from "embla-carousel-react"
import Autoplay from "embla-carousel-autoplay"
import { MdOutlineStar } from "react-icons/md"
import { CiUser } from "react-icons/ci"
import { RiVerifiedBadgeLine } from "react-icons/ri"

// Clutch Rating component using Embla Carousel
const CluthRating = ({ props }: any) => {
  const [emblaRef] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      slidesToScroll: 1,
      containScroll: "trimSnaps",
      dragFree: false,
    },
    [Autoplay({ delay: 2000, stopOnInteraction: false })],
  )

  // Render star rating dynamically based on review.rating
  const renderStars = (rating: number) => {
    const stars = []
    for (let i = 0; i < 5; i++) {
      if (i < rating) {
        stars.push(<MdOutlineStar key={i} className="text-pink text-[18px]" />)
      } else {
        stars.push(<MdOutlineStar key={i} className="text-gray-300 text-[18px]" />)
      }
    }
    return stars
  }

  return (
    <div className="py-12 block lg:py-0">
      <div className="bg-white rounded-xl p-6 mx-auto">
        {/* Title and Overall Ratings Section */}
        <div className="flex gap-5 items-center flex-wrap">
          <h2 className="text-homeblack font-semibold">Our Ratings on Clutch</h2>
          <div className="flex justify-start items-center">
            <p className="text-[28px] font-semibold text-homeblack">4.9</p>
            <div className="flex text-pink text-[20px]">{renderStars(5)}</div>
          </div>
        </div>
          <p className="text-[16px] text-pink">43 Reviews on Clutch</p>

        {/* Customer Reviews Section */}
        <div className="mt-5">
          {/* Embla Carousel for Reviews */}
          <div className="mt-5">
            <div className="embla overflow-hidden" ref={emblaRef}>
              <div className="embla__container flex">
                {props?.map((review: any, index: any) => (
                  <div key={index} className="embla__slide flex-shrink-0 mr-4" style={{ width: "350px" }}>
                    <div className="flex flex-col gap-4 relative border-2 w-full border-red-200 p-6 h-[261px] hover:shadow-lg transition-all duration-300 rounded-lg bg-white">
                      <div className="flex justify-between items-center">
                        <div className="flex justify-start items-center">
                          <p className="text-[20px] font-semibold text-homeblack">
                            {Number.parseFloat(review?.rating).toFixed(1)}
                          </p>
                          <div className="flex text-pink text-[18px]">{renderStars(review?.rating)}</div>
                        </div>
                        <div className="flex gap-2">
                          <RiVerifiedBadgeLine />
                          <p className="text-[12px] text-homeblack">Verified Review</p>
                        </div>
                      </div>
                      <div className="p-4 text-[14px] rounded-lg text-homegrey flex-1">
                        <div>{review?.review}</div>
                      </div>
                      <div className="flex items-center gap-3">
                        <div className="flex justify-center items-center bg-red-100 rounded-full min-w-[49px] h-[49px]">
                          <CiUser className="text-[28px] text-red" />
                        </div>
                        <p className="text-[14px] font-medium">{review?.position}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CluthRating
